import { render, staticRenderFns } from "./PerfilesIndex.vue?vue&type=template&id=3ce08d40"
import script from "./PerfilesIndex.vue?vue&type=script&lang=js"
export * from "./PerfilesIndex.vue?vue&type=script&lang=js"
import style0 from "./PerfilesIndex.vue?vue&type=style&index=0&id=3ce08d40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports